import { Form } from 'antd';
import PackagingFormItems from 'components/pages/dashboard/packaging/create/components/PackagingFormItems';
import { getPackagingContent, getPackagingTypeList, getUnusualPackagingType } from 'components/pages/dashboard/packaging/create/components/packagingFunctions';
import TcButton from 'components/UI/button/TcButton';
import TcForm from 'components/UI/form/TcForm';
import TcFormWrapper from 'components/UI/FormWrapper/TcFormWrapper';
import TcCoverLoading from 'components/UI/loading/TcCoverLoading';
import { defaultSegmentPackage } from 'global/Constants/globalConstants';
import { convertFormValuesToEnglishNumber, separator } from 'global/default';
import { convertFormValuesToEnglishDouble } from 'global/helperFunctions/default';
import { packagingContent, packagingGroup, packagingType } from 'global/Models/packaging';
import { packaging } from 'global/Models/packagingModel';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const shouldBeNumber: string[] = ['price'];
const shouldBeDouble: string[] = ['weight', 'width', 'height', 'length'];

interface IStandardPackaging {
  handleSelect?: (_pack: packaging) => void;
  notifNotStandard?: boolean;
  //this form used in many places with different submit handlers, so i created this props(external*) to handle loading state and submit in different places
  externalSubmitHandler?: (_values: any) => void;
  externalLoading?: boolean;
}

const BranchStandardPackaging: FC<IStandardPackaging> = ({ handleSelect, externalSubmitHandler, externalLoading }) => {
  //state

  const [selectingPackagingGroup, setSelectingPackagingGroupId] = useState<packagingGroup>(defaultSegmentPackage);
  const [packagingTypeList, setPackagingTypeList] = useState<packagingType[]>();
  const [selectedPackagingType, setSelectedPackagingType] = useState<packagingType>();
  const { packagingGroup, packagingLoading } = useSelector((state: RootState) => state.packaging);
  const [packagingContent, setPackagingContent] = useState<packagingContent[]>();
  const [inputPrice, setInputPrice] = useState<string>('');

  //hooks
  const [form] = Form.useForm();

  //effect
  useEffect(() => {
    packagingGroup && form.setFieldValue('packagingGroupId', selectingPackagingGroup.id);
    packagingGroup && getPackagingTypeList(selectingPackagingGroup.id, setPackagingTypeList);
    packagingGroup && getPackagingContent(selectingPackagingGroup.id, setPackagingContent);
  }, [packagingGroup]);

  useEffect(() => {
    if (packagingTypeList) {
      let defaultPackagingType;
      //if parcel is flyer and NC ==> doesn't have "نیاز به بسته بندی ندارد!" or order == 0 then :
      if (selectingPackagingGroup.id == 50 || selectingPackagingGroup.id == 30) {
        defaultPackagingType = packagingTypeList.find((pt) => pt.order === 1);
      } else {
        defaultPackagingType = packagingTypeList.find((pt) => pt.order === 0);
      }
      if (!defaultPackagingType) return;

      form.setFieldValue('packagingTypeId', defaultPackagingType.id);
      if (defaultPackagingType.packagingGroupId === 20) getUnusualPackagingType(setSelectedPackagingType);
      else setSelectedPackagingType(defaultPackagingType);
    }
  }, [packagingTypeList]);

  ///function
  const handleValuesChange = (value: any, values: Record<string, any>) => {
    convertFormValuesToEnglishDouble(value, values, shouldBeDouble, form, true);
    convertFormValuesToEnglishNumber(value, values, shouldBeNumber, form, true);

    if (value.packagingGroupId) {
      getPackagingTypeList(value.packagingGroupId, setPackagingTypeList);
      getPackagingContent(value.packagingGroupId, setPackagingContent);

      if (value.packagingGroupId == '30') {
        // getUnusualPackagingType(setSelectedPackagingType);
        getPackagingContent(20, setPackagingContent);
      } else if (value.packagingGroupId == '20') {
        getPackagingContent(20, setPackagingContent);
        getUnusualPackagingType(setSelectedPackagingType);
      }
      form.setFieldValue('packagingContentId', undefined);
    }
    if (value.packagingTypeId === 0) {
      getUnusualPackagingType(setSelectedPackagingType);
    }
    if (value.packagingTypeId && packagingTypeList) {
      setSelectedPackagingType(packagingTypeList.find((pt) => pt.id === value.packagingTypeId));
    }
    if (value.price) setInputPrice(separator(form.getFieldValue('price')) + ' ' + 'ریال');
    else setInputPrice('');
  };

  const handleSubmit = async (values: any) => {
    if (!selectedPackagingType) return;

    if (selectedPackagingType.order !== 0 && selectedPackagingType.order !== 10000) {
      values.height = selectedPackagingType.height;
      values.length = selectedPackagingType.length;
      values.width = selectedPackagingType.width;
    }

    if (externalSubmitHandler) {
      externalSubmitHandler(values);
      return;
    }

    // Locally save from datas in handleSelect
    if (handleSelect) {
      handleSelect({
        ...values,
        isStandard: true, // or set as needed
        title: values.title || '', // or set as needed
      });
    }
    return;
  };

  if (externalSubmitHandler)
    return (
      <TcForm onValuesChange={handleValuesChange} form={form} onFinish={handleSubmit} validateTrigger='onSubmit'>
        <TcFormWrapper>
          <PackagingFormItems
            packagingContent={packagingContent}
            packagingTypeList={packagingTypeList}
            selectedPackagingType={selectedPackagingType}
            selectingPackagingGroup={selectingPackagingGroup}
            setSelectingPackagingGroupId={setSelectingPackagingGroupId}
            noTitle={true}
            inputPriceValue={inputPrice}
          />
        </TcFormWrapper>
        <div className='flex justify-center mt-10'>
          <TcButton loading={externalLoading} type='primary' htmlType='submit'>
            محاسبه هزینه
          </TcButton>
        </div>
      </TcForm>
    );

  return (
    <div className='relative p-5 border rounded-md bg-t-bg-color border-t-border-color-base'>
      <TcForm onValuesChange={handleValuesChange} form={form} onFinish={handleSubmit} validateTrigger='onSubmit'>
        <TcFormWrapper>
          <PackagingFormItems
            packagingContent={packagingContent}
            packagingTypeList={packagingTypeList}
            selectedPackagingType={selectedPackagingType}
            inputPriceValue={inputPrice}
            selectingPackagingGroup={selectingPackagingGroup}
            setSelectingPackagingGroupId={setSelectingPackagingGroupId}
          />
        </TcFormWrapper>
        <div className='flex justify-end my-3'>
          <TcButton type='primary' htmlType='submit'>
            ثبت
          </TcButton>
        </div>
      </TcForm>
      {packagingLoading && <TcCoverLoading />}
    </div>
  );
};

export default BranchStandardPackaging;
